import { render, staticRenderFns } from "./CheckboxFacetGroup.vue?vue&type=template&id=4e978fac&scoped=true"
import script from "./CheckboxFacetGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxFacetGroup.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxFacetGroup.vue?vue&type=style&index=0&id=4e978fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e978fac",
  null
  
)

export default component.exports